import React from "react";
import {
    Drawer,
    Typography,
    IconButton,
    Grid,
    Button,
    Card,
    CardContent,
    TextField,
    Box,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import {thousandSeparator, truncateText} from "../utils/Utils";
import {useCart} from "../context/CartContext";
import {useHistory} from "react-router-dom";
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';

const CartDrawer = () => {
    const history = useHistory()
    const { cartItems, calculateTotal, isCartOpen, closeCart, removeFromCart, updateQuantity } = useCart();

    return (
        <Drawer anchor="right" open={isCartOpen} onClose={closeCart}>
            <Box sx={{ width: 350, p: 2 }}>
                <Typography variant="h5" gutterBottom>
                    Kosár
                </Typography>
                {cartItems.length === 0 ? (
                    <Typography variant="body1">A kosár üres.</Typography>
                ) : (
                    <Grid container spacing={2}>
                        {cartItems.map((item) => (
                            <Grid item xs={12} key={item.id}>
                                <Card>
                                    <CardContent>
                                        <Typography variant="h6">{item.name}</Typography>
                                        <Typography variant="body2" color="textSecondary">
                                            {truncateText(item?.description, 150)}
                                        </Typography>
                                        <Typography variant="body1" color="primary">
                                            {thousandSeparator(item.price)} Ft
                                        </Typography>
                                        <div style={{ display: "flex", alignItems: "center", marginTop: "10px" }}>
                                            <IconButton onClick={() => updateQuantity(item, -1)}>
                                                <RemoveIcon />
                                            </IconButton>
                                            <TextField
                                                value={item.quantity}
                                                variant="standard"
                                                inputProps={{ style: { textAlign: "center" } }}
                                                style={{ width: "50px", textAlign: "center" }}
                                            />
                                            <IconButton onClick={() => updateQuantity(item, 1)}>
                                                <AddIcon />
                                            </IconButton>
                                            <IconButton onClick={() => removeFromCart(item.id)}>
                                                <DeleteForeverRoundedIcon />
                                            </IconButton>
                                        </div>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                        <Grid item xs={12}>
                            <Typography variant="h6">
                                Összesen: {thousandSeparator(calculateTotal())} Ft
                            </Typography>
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                fullWidth
                                startIcon={<ShoppingCartCheckoutIcon />}
                                onClick={() => {
                                    history.push('/checkout');
                                    closeCart();
                                }}
                            >
                                Megrendelem
                            </Button>
                        </Grid>
                    </Grid>
                )}
            </Box>
        </Drawer>
    );
};

export default CartDrawer;
